export const QUESTIONS = [
  {
    question: 'What is the meaning of life?',
    answer:
      'The meaning of life is subjective and can vary from person to person. It may involve finding personal fulfillment, achieving goals, making a positive impact on the world, or experiencing happiness and joy.'
  },
  {
    question: 'How do I improve my productivity?',
    answer:
      'There are several ways to improve productivity, such as setting clear goals, prioritizing tasks, minimizing distractions, taking breaks, and using productivity tools and techniques.'
  },
  {
    question: 'What is the best way to invest my money?',
    answer:
      'The best way to invest your money depends on your financial goals, risk tolerance, and investment horizon. Some common investment options include stocks, bonds, mutual funds, real estate, and alternative investments.'
  },
  {
    question: 'How can I lose weight effectively?',
    answer:
      'Effective weight loss involves a combination of healthy eating habits, regular exercise, and a positive mindset. Some helpful tips include eating more fruits and vegetables, drinking plenty of water, reducing portion sizes, and avoiding processed foods.'
  },
  {
    question: 'What are the symptoms of COVID-19?',
    answer:
      "The symptoms of COVID-19 can vary, but common ones include fever, cough, fatigue, loss of smell or taste, and difficulty breathing. If you experience these symptoms, it's important to get tested and follow guidelines from your local health authorities."
  }
]
